import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { ToolTipBox, HoverableElement } from 'components/ToolTip/styles';
import { BUTTON_PRIMARY } from 'components/TCButton/styles';
import { InputIconFieldHoverContainer } from 'components/InputIcon/styles'


export interface SectionWrapperProps {
    margin?: string
    padding?: string
    justifyContent?: string
    minWidth?: string
    maxWidth?: string
    maxHeight?: string
    flexFlow?: string
}

export const SectionWrapper = styled.div`
    justify-content: ${(props: SectionWrapperProps) => props.justifyContent ? props.justifyContent : 'center'};
    margin: ${(props: SectionWrapperProps) => props.margin ? props.margin : ''};
    flex-flow: ${(props: SectionWrapperProps) => props.flexFlow ? props.flexFlow : ''};
    padding: ${(props: SectionWrapperProps) => props.padding ? props.padding : ''};
    min-width: ${(props: SectionWrapperProps) => props.minWidth ? props.minWidth : ''};
    max-width: ${(props: SectionWrapperProps) => props.maxWidth ? props.maxWidth : ''};
    max-height: ${(props: SectionWrapperProps) => props.maxHeight ? props.maxHeight : ''};
`;

export const IconContainer = styled.div`    
    display: flex;     
    justify-content: center;
    width:35px;   
`

export const Container = styled.div`       
    margin-top: 7px;
`

export interface LabelProps {
    margin?: string
    marginTop?: string
    flexFlow?: string;
}

export const Row = styled.div` 
    display: flex ;
    margin-top: 8px;
    gap: 10px;
    flex-flow: ${(props: LabelProps) => props.flexFlow ? props.flexFlow : 'none'};
`

export const Label = styled.label`    
    font-family: Rubik;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #bdbdbd; 
    width: 50%;
    display: block ;
    margin-bottom: 6px;
    margin-top: ${(props: LabelProps) => props.marginTop ? props.marginTop : 'none'};
`

export const ViewLabelUrl = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #4da0ff;
    text-decoration: underline;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 45%;

    margin-bottom: ${(props: LabelProps) => props.margin ? props.margin : '7px'};
    margin-top: ${(props: LabelProps) => props.marginTop ? props.marginTop : '4px'};
`

export const ViewLabel = styled.span`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #000000;
    overflow-wrap: break-word;
    word-break: break-all;
    margin-bottom: ${(props: LabelProps) => props.margin ? props.margin : 'unset'};
`

export const ViewLabelNumber = styled.div`
    width: 50%;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    margin-bottom: ${(props: LabelProps) => props.margin ? props.margin : '7px'};
`

export const Input = styled.input`
    display: block;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    color: #3D3D3D;
    outline: none;
    padding: 10px 13.7px;
    border-radius: 5px;
    border: solid 1px #ebecf0;
    flex:1;
    width: 70%;
    margin-bottom: 7px; 
`

export const InputTextarea = styled.textarea`
    display: flex;
    width: calc(100% - ${SIZE.TWO}px);
    padding: ${SIZE.ONE}px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    outline: none;
    border-radius: 5px;
    border: solid 1px #ebecf0;
    overflow: auto;
    min-height: ${SIZE.FIFTEEN}px; 
    color: #3D3D3D;
    resize:none;
`

export const EmptyText = styled.span`
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #bdbdbd;
    margin-bottom: 23px;
`